import { render, staticRenderFns } from "./AdminChips.vue?vue&type=template&id=fb7a7a46"
import script from "./AdminChips.vue?vue&type=script&lang=js"
export * from "./AdminChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports